export const createRedirectUrl = (pageName, planName) => {
  return `/tilaa/${pageName.toLowerCase()}-${planName
    .replace(/\s/g, "")
    .toLowerCase()}`
}
